module.exports = __webpack_public_path__ + "static/media/teacher.436c21c7.jpg";